import { render, staticRenderFns } from "./el-crud.vue?vue&type=template&id=d687fb7e&"
import script from "./el-crud.vue?vue&type=script&lang=js&"
export * from "./el-crud.vue?vue&type=script&lang=js&"
import style0 from "./el-crud.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "el-crud.vue"
export default component.exports